/* ============================================================================
   csf-cart-extras.js — discount-preset behaviour for the offcanvas cart.
   - "Show all coupons" reveals the extra chips.
   - Clicking a coupon applies it to the real cart (cart-container.applyDiscountCode),
     so the totals that follow are Shopify's own figures and match checkout.
     It no longer estimates the discount from theme settings.
   Uses event delegation on document so it keeps working after the cart drawer
   re-renders on quantity changes.
   ========================================================================== */
(function () {
  function setChipState(chip, state) {
    var wrap = chip.closest('.cd-presets-wrap');
    if (wrap) wrap.querySelectorAll('.cd-chip').forEach(function (c) { c.classList.remove('is-active', 'is-invalid'); });
    if (state) chip.classList.add(state);
  }

  async function applyPreset(chip) {
    var code = chip.getAttribute('data-code');
    var container = document.querySelector('cart-container');
    if (!code || !container || typeof container.applyDiscountCode !== 'function') return;

    chip.classList.add('is-loading');
    var result = await container.applyDiscountCode(code);
    chip.classList.remove('is-loading');

    /* The drawer re-renders during apply, so re-find this chip before marking it. */
    var fresh = document.querySelector('.cd-chip[data-code="' + code.replace(/"/g, '\\"') + '"]') || chip;
    setChipState(fresh, result && result.applied ? 'is-active' : 'is-invalid');
  }

  document.addEventListener('click', function (e) {
    var showAll = e.target.closest('.cd-showall');
    if (showAll) {
      var w = showAll.closest('.cd-presets-wrap');
      if (w) w.querySelectorAll('.cd-chip--extra').forEach(function (c) { c.classList.add('is-shown'); });
      showAll.setAttribute('hidden', '');
      return;
    }
    var chip = e.target.closest('.cd-chip');
    if (chip) applyPreset(chip);
  });
})();
